(() => {
  if (window.PPDeviceRefills) {
    window.PPDeviceRefills.initialize(document);
    return;
  }
  const shopRoot = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  const serial = operation => {
    const next = queue.then(operation, operation);
    queue = next.catch(() => {});
    return next;
  };
  const readCart = async (signal = AbortSignal.timeout(12000)) => {
    const response = await fetch(shopRoot + 'cart.js', {cache: 'no-store', headers: {Accept: 'application/json'}, signal});
    if (!response.ok) throw new Error('cart');
    return response.json();
  };
  const request = async (path, payload, fallback, signal) => {
    if (!window.PPSubscription) throw new Error(fallback);
    const sections=[];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections',{bubbles:true,detail:{sections}}));
    payload={...payload,sections:[...new Set(sections)].slice(0,5),sections_url:location.pathname};
    const response = await window.PPSubscription.request(shopRoot + path, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(payload)
    }, {signal, inlineErrors: true});
    const data = await response.json();
    if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || fallback);
    return data._ppCart || data;
  };
  const refreshCart = cart => {
    document.dispatchEvent(new CustomEvent('cart:updated', {bubbles: true, detail: {cart}}));
    if (cart.sections && Object.values(cart.sections).every(Boolean) && window.theme?.pubsub) {
      window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate,{source:'pp-device-refills',cart});
      document.querySelector('cart-drawer')?.show();
    } else document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true, detail: {open: true}}));
    document.dispatchEvent(new CustomEvent('loop:cart:updated', {bubbles: true}));
    if (!document.querySelector('cart-drawer')) location.assign(shopRoot + 'cart');
  };
  const initialize = scope => scope.querySelectorAll('[data-pp-device-refills]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const {mainVariantIds, strings} = JSON.parse(root.querySelector('[data-refill-config]').textContent);
    const deviceIds = new Set(mainVariantIds.map(String));
    const cartError = root.querySelector('.pp-refill-cart-error');
    const selected = new Map();
    let committed = new Set();
    let touched = false;
    let busy = false;
    const controls = [...root.querySelectorAll('.pp-refill-card')].map(card => {
      const key = card.dataset.key;
      const button = card.querySelector('.pp-refill-choose');
      const check = card.querySelector('.pp-refill-check');
      const dialog = root.querySelector('[data-plan-dialog="' + key + '"]');
      const confirm = dialog.querySelector('.pp-refill-confirm');
      const remove = dialog.querySelector('.pp-refill-remove');
      const error = dialog.querySelector('.pp-refill-error');
      const regions = [...dialog.querySelectorAll('[data-refill-region]')];
      const plans = [...dialog.querySelectorAll('[data-refill-plan]')];
      const renewal = dialog.querySelector('.pp-refill-dialog-renewal');
      const findLine = cart => cart.items.find(item => item.selling_plan_allocation && regions.some(region => String(item.variant_id) === region.value));
      const defaults = () => ({key, variantId: Number(regions[0].value), sellingPlanId: Number(plans[0].value)});
      const render = () => {
        const chosen = selected.has(key);
        card.classList.toggle('is-selected', chosen);
        check.textContent = chosen ? '✓' : '';
        check.setAttribute('aria-checked', String(chosen));
        check.disabled = busy;
        button.disabled = busy;
        button.textContent = chosen ? strings.edit : strings.choose;
        button.setAttribute('aria-expanded', String(dialog.open));
      };
      const renderPrice = () => {
        renewal.textContent = plans.find(plan => plan.checked).dataset.months === '1' ? renewal.dataset.monthly : renewal.dataset.bimonthly;
      };
      const open = (event, selectingRegion = false) => {
        event?.stopPropagation();
        if (busy || dialog.open) return;
        const current = selected.get(key) || defaults();
        dialog.dataset.selectionMode = String(selectingRegion);
        regions.forEach(region => region.checked = !selectingRegion && Number(region.value) === current.variantId);
        confirm.textContent = selectingRegion ? strings.confirm_region : strings.confirm;
        confirm.disabled = selectingRegion;
        dialog.querySelector('.pp-refill-schedule').hidden = selectingRegion;
        dialog.querySelector('.pp-refill-dialog-price').hidden = selectingRegion;
        renewal.hidden = selectingRegion;
        plans.forEach(plan => plan.checked = Number(plan.value) === current.sellingPlanId);
        if (!plans.some(plan => plan.checked)) plans[0].checked = true;
        remove.hidden = selectingRegion || !selected.has(key);
        error.hidden = true;
        error.textContent = '';
        renderPrice();
        dialog.showModal();
        render();
      };
      const toggle = () => {
        if (busy) return;
        touched = true;
        if (selected.has(key)) selected.delete(key);
        else if (regions.length > 1) {open(null, true); return;}
        else selected.set(key, defaults());
        cartError.hidden = true;
        render();
      };
      check.addEventListener('click', event => {event.stopPropagation(); toggle();});
      card.addEventListener('click', event => {
        if (event.target.closest('button')) return;
        if (regions.length > 1) open(event);
        else toggle();
      });
      regions.forEach(region => region.addEventListener('change', () => {confirm.disabled = false;}));
      button.addEventListener('click', open);
      plans.forEach(plan => plan.addEventListener('change', renderPrice));
      dialog.querySelector('.pp-refill-close').addEventListener('click', () => {if (!busy) dialog.close();});
      dialog.addEventListener('click', event => {if (event.target === dialog && !busy) dialog.close();});
      dialog.addEventListener('cancel', event => {if (busy) event.preventDefault();});
      dialog.addEventListener('close', () => {render(); button.focus();});
      confirm.addEventListener('click', () => {
        if (busy || !regions.some(region => region.checked)) return;
        touched = true;
        selected.set(key, {key, variantId: Number(regions.find(region => region.checked).value), sellingPlanId: Number(plans.find(plan => plan.checked).value)});
        render();
        if (dialog.dataset.selectionMode === 'true') dialog.close();
        else perform({dialog, error, button: confirm});
      });
      remove.addEventListener('click', () => {
        if (busy) return;
        touched = true;
        selected.delete(key);
        render();
        dialog.close();
      });
      return {key, findLine, render, dialog};
    });
    const sync = cart => {
      if (!Array.isArray(cart?.items)) return;
      const present = new Set();
      controls.forEach(control => {
        const line = control.findLine(cart);
        if (line) {
          present.add(control.key);
          if (!touched) selected.set(control.key, {key: control.key, variantId: Number(line.variant_id), sellingPlanId: Number(line.selling_plan_allocation.selling_plan.id)});
        } else if (committed.has(control.key)) selected.delete(control.key);
      });
      committed = present;
      controls.forEach(control => control.render());
    };
    const replaceVariant = async (current, item, control, signal) => {
      await request('cart/change.js', {id: current.key, quantity: 0}, strings.error, signal);
      try {
        await request('cart/add.js', {items: [item]}, strings.error, signal);
      } catch (failure) {
        signal.throwIfAborted();
        const after = await readCart(signal);
        if (!control.findLine(after)) {
          try {
            await request('cart/add.js', {items: [{id: current.variant_id, quantity: current.quantity, selling_plan: current.selling_plan_allocation.selling_plan.id, properties: current.properties}]}, strings.error, signal);
          } catch (_) {throw new Error(strings.restore_error);}
        }
        throw failure;
      }
    };
    const perform = async ({form, button, dialog, error = cartError}) => {
      if (busy) return;
      const choices = [...selected.values()];
      if (!choices.length) return;
      let mainItem;
      if (form) {
        const data = new FormData(form);
        const quantity = Number(data.get('quantity') || 1);
        if (!deviceIds.has(String(data.get('id'))) || !Number.isSafeInteger(quantity) || quantity < 1) return;
        mainItem = {id: Number(data.get('id')), quantity, properties: {}};
        for (const [name, value] of data) {
          const property = name.match(/^properties\[(.+)\]$/);
          if (property && typeof value === 'string') mainItem.properties[property[1]] = value;
        }
        if (data.get('selling_plan')) mainItem.selling_plan = Number(data.get('selling_plan'));
      }
      busy = true;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 35000);
      const signal = controller.signal;
      const expired = new Promise((_, reject) => signal.addEventListener('abort', () => reject(signal.reason), {once: true}));
      error.textContent = '';
      error.hidden = true;
      controls.forEach(control => control.render());
      if (dialog) {
        dialog.setAttribute('aria-busy', 'true');
        dialog.querySelectorAll('button, input').forEach(input => input.disabled = true);
      }
      if (button) {button.setAttribute('loading', ''); button.setAttribute('aria-busy', 'true'); button.disabled = true;}
      try {
        const cart = await Promise.race([serial(async () => {
          signal.throwIfAborted();
          let latest = await readCart(signal);
          const additions = mainItem ? [mainItem] : [];
          for (const choice of choices) {
            const control = controls.find(control => control.key === choice.key);
            const current = control.findLine(latest);
            const item = {
              id: choice.variantId, quantity: 1, selling_plan: choice.sellingPlanId,
              properties: {...current?.properties, _pp_subscription_addon: choice.key, _loop_selling_plan: String(choice.sellingPlanId), _selling_plan: String(choice.sellingPlanId)}
            };
            if (!current) additions.push(item);
            else if (Number(current.variant_id) !== choice.variantId) {
              await replaceVariant(current, item, control, signal);
              latest = await readCart(signal);
            } else if (Number(current.selling_plan_allocation.selling_plan.id) !== choice.sellingPlanId) {
              await request('cart/change.js', {id: current.key, quantity: current.quantity, selling_plan: choice.sellingPlanId, properties: item.properties}, strings.error, signal);
              latest = await readCart(signal);
            }
          }
          if (additions.length) {
            const added = await request('cart/add.js', {items: additions}, strings.error, signal);
            if (mainItem && additions.length === 1) {
              const updated = await readCart(signal);
              if (added.sections) updated.sections = added.sections;
              return updated;
            }
            return added;
          }
          return window.PPSubscription.reconcile({signal, inlineErrors: true});
        }), expired]);
        sync(cart);
        document.dispatchEvent(new CustomEvent('pp:refills-cart', {detail: {cart}}));
        dialog?.close();
        refreshCart(cart);
      } catch (failure) {
        error.textContent = signal.aborted ? strings.timeout : failure.message === 'cart' ? strings.error : failure.message || strings.error;
        error.hidden = false;
      } finally {
        clearTimeout(timer);
        busy = false;
        if (button) {button.disabled = false; button.removeAttribute('loading'); button.removeAttribute('aria-busy');}
        if (dialog) {
          dialog.removeAttribute('aria-busy');
          dialog.querySelectorAll('button, input').forEach(input => input.disabled = false);
        }
        controls.forEach(control => control.render());
      }
    };
    const shouldTakeOver = form => root.isConnected && form?.matches('form[action*="/cart/add"]') && deviceIds.has(String(new FormData(form).get('id'))) && selected.size > 0;
    document.addEventListener('click', event => {
      const button = event.target.closest('button[name="add"], button[type="submit"], input[type="submit"]');
      const form = button?.form;
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' || !shouldTakeOver(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.reportValidity()) perform({form, button});
    }, true);
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!shouldTakeOver(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = event.submitter || form.querySelector('[name="add"]');
      if (button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
      perform({form, button});
    }, true);
    document.addEventListener('pp:refills-cart', event => sync(event.detail.cart));
    document.addEventListener('cart:updated', event => sync(event.detail?.cart));
    readCart().then(sync).catch(() => {});
  });
  window.PPDeviceRefills = {initialize};
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
